import { getUserContext } from '@cbhq/client-analytics';
import { Client, init } from '@cbhq/error-vitals-web';

let ErrorVitalsClient: Client | undefined;

export function initErrorVitals() {
  try {
    ErrorVitalsClient = init({
      apiKey: String(process.env.NEXT_PUBLIC_ERROR_VITALS_API_KEY),
      environment: String(process.env.NEXT_PUBLIC_NEXT_ENV),
      appVersion: String(process.env.NEXT_PUBLIC_APP_VERSION),
      useGlobalHandlers: true,
      getUserContext,
    });
  } catch (error) {
    console.error('Error initializing Error Vitals', error);
  }
}

export function getErrorVitals() {
  return ErrorVitalsClient;
}
